import React from 'react'
import type { PropsWithChildren, FC } from 'react'
import Divider from '../Divider'
import { DIVIDER_VARIANT } from '../Divider/constants'
import { Container } from './styles'

const FooterWrapper: FC<PropsWithChildren> = ({ children }) => (
  <Container>
    <Divider variant={DIVIDER_VARIANT.line} fullWidth fullSize removeHeight />
    {children}
  </Container>
)

export default FooterWrapper
